import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from '../../../constants';

//Styles

class EmailSignature extends Component {
    static propTypes = {
        siteName: PropTypes.string.isRequired,
    }
    render() {
        const { siteName } = this.props;
        return (
            <div>
                Gracias, <br />
                El Equipo de {siteName}
                <a href="https://eslipin.com" style={{ color: PRIMARY_COLOR, textDecoration: 'none' }}>eslipin.com</a>
            </div>
        )
    }
}

export default EmailSignature;